import React from 'react';
import { Menubar } from 'primereact/menubar';
import { useNavigate } from 'react-router-dom';

const MenuUniformesValidacion = ({link}) => {

    const navigate = useNavigate();

    console.log("MenuUniformesValidacion");

    const nestedMenuitems = [
        {
            label: 'Validación',
            icon: 'pi pi-fw pi-pencil',
            command: e => {
                navigate('/validacion');
            }
        }
    ];

    return (
        <div className="col-12" style={{marginBottom: "15px"}}>
            <Menubar model={nestedMenuitems} className="surface-card"></Menubar>
        </div>
    );
}

export default MenuUniformesValidacion;